module.exports = __webpack_public_path__ + "static/fajolu-1a016f037f66934566ab49a199a2a7d9.png";